import { CHANGE_LANGUAGE } from './actionTypes';

const I18nActions = {
  setLanguage(language) {
    return { type: CHANGE_LANGUAGE, language };
  },
};

export { I18nActions };
